import { Component, Input, OnInit } from '@angular/core';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import SlotFirstPageModel from '../../models/slot-first-page.model';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { ICartDetails } from '../../interfaces/cart-details.interface';
import { YourOfferService } from '../../cart-process/your-offer.service';

@Component({
  selector: '[new-offer-section]',
  templateUrl: './new-offer-section.component.html',
})
export class NewOfferSectionComponent implements OnInit {
  @Input() protected slots: SlotFirstPageModel[];

  public memberHtmlField: string;

  constructor(
    public yourOffer: YourOfferService,
    public commonInfo: CommonInfoService,
    private notificationProvider: NotificationProviderService,
  ) {}

  ngOnInit(): void {
    this.notificationProvider.subscribe(NotificationProviderTypeEnum.CART_DETAILS, (cartDetails: ICartDetails) => {
      if (cartDetails && cartDetails.memberHtmlField) {
        this.memberHtmlField = cartDetails.memberHtmlField;
      }
    });
  }

  public isBohoOfferAndOwnerSlot(slot: SlotFirstPageModel): boolean {
    return this.commonInfo.isBohoOffer && slot.isOwner;
  }

  public isCommonOfferSlot(slot: SlotFirstPageModel): boolean {
    return !this.commonInfo.isBohoOffer || (this.commonInfo.isBohoOffer && !slot.isOwner);
  }

  public showDiscountBar(slotIndex: number): boolean {
    const sumSlotsAndCurrentlyProcessed = this.slots.length + this.commonInfo.currentlyProcessed;
    const requiredParticipants = this.commonInfo.simCardDiscount?.requiredParticipants;

    return this.commonInfo.simCardDiscount
      // flag below is null when discount is unavailable
      && (this.commonInfo.simCardDiscountApplied === true || this.commonInfo.simCardDiscountApplied === false)
      && slotIndex === requiredParticipants - 2 && this.slots.length >= requiredParticipants - 1 && !this.commonInfo.isNextSim
      || this.commonInfo.isNextSim && slotIndex + this.commonInfo.currentlyProcessed === requiredParticipants - 2
      && sumSlotsAndCurrentlyProcessed >= requiredParticipants - 1
      && !(this.slots.length === 1 && sumSlotsAndCurrentlyProcessed === requiredParticipants)
      && this.commonInfo.currentlyProcessed <= requiredParticipants - 1;
  }
}

